export default {
    laptop: [
        {
            question: 'What is the Laptop Broadcast category?',
            answer: `<p>The Laptop Broadcast category shows live <strong>Want-to-Buy (WTB)</strong> and <strong>Want-to-Sell (WTS)</strong> posts for laptops, notebooks, and related hardware in the circular IT market.</p>
                    <p>You will typically find brands such as Apple, Lenovo, HP, Dell, Fujitsu, ASUS, and MSI, plus components and accessories including chargers, batteries, screens, keyboards, and docking stations.</p>`
        },
        {
            question: 'How do I see only Want-to-buy (WTB) laptop offers?',
            answer: `<p>Use the list-type filter in Broadcast Search and select <strong>WTB</strong>, or open this direct URL: https://www.thebrokersite.com/broadcasts-refurbished-laptops/wtb</p>
                    <p>Sign in to view full details and contact information. If you are new, you can apply for a trial at https://www.thebrokersite.com/register</p>`
        },
        {
            question: 'How do I see only Want-to-sell (WTS) laptop offers?',
            answer: `<p>Use the list-type filter in Broadcast Search and select <strong>WTS</strong>, or open this direct URL: https://www.thebrokersite.com/broadcasts-refurbished-laptops/wts</p>
                    <p>Sign in to access complete listings and supplier contact details. New users can register for a trial at https://www.thebrokersite.com/register</p>`
        },
        {
            question: 'How can I receive laptop broadcasts by email?',
            answer: `<p>To receive laptop broadcasts by email, your company needs an active TheBrokerSite membership.</p>
                    <p>After verification and activation, you can subscribe to relevant broadcast lists and receive updates directly in your inbox, including full post details and sender contact information.</p>`
        },
        {
            question: 'Why did a laptop broadcast disappear or move down quickly?',
            answer: `<p>The feed updates continuously with a high daily volume of new broadcasts, so listings can move to later pages quickly.</p>
                    <p>Posts may also be removed by the sender once a deal is completed or inventory is no longer available.</p>`
        },
        {
            question: 'Which laptop types are commonly traded on TheBrokerSite?',
            answer: `<p>You can find many segments, including:</p>
                    <ul>
                      <li>Business laptops (for example ThinkPad and EliteBook ranges)</li>
                      <li>Refurbished MacBooks (MacBook Air and MacBook Pro)</li>
                      <li>Gaming laptops with dedicated graphics</li>
                      <li>Budget and education-focused notebooks</li>
                    </ul>
                    <p>Availability changes daily based on active WTB and WTS demand.</p>`
        },
        {
            question: 'Can I search laptop broadcasts by brand, model, or specs?',
            answer: `<p>Yes. Use keyword search and filters to narrow by brand, model family, CPU, RAM, storage, condition, or other terms included by the seller or buyer.</p>
                    <p>For best results, combine a category filter (Laptop) with specific model keywords such as "ThinkPad T14", "Latitude 7420", or "MacBook Pro M1".</p>`
        },
        {
            question: 'Are the laptops in this category new or refurbished?',
            answer: `<p>Most listings in this B2B channel involve used, refurbished, or ex-lease devices, although listing condition depends on each member post.</p>
                    <p>Always review the broadcast details and confirm grading, warranty terms, battery condition, and cosmetic state directly with the trading partner.</p>`
        },
        {
            question: 'How do I post a WTB or WTS laptop broadcast?',
            answer: `<p>After signing in, open the Broadcast page, choose the <strong>Laptop</strong> category, select <strong>WTB</strong> or <strong>WTS</strong>, and add a clear description with quantity, condition, and preferred region.</p>
                    <p>A detailed post improves response quality and helps you close deals faster.</p>`
        },
        {
            question: 'Is TheBrokerSite laptop marketplace suitable for international trade?',
            answer: `<p>Yes. TheBrokerSite connects IT traders and suppliers across multiple countries, making it suitable for both local and cross-border laptop sourcing.</p>
                    <p>For international deals, include region, logistics expectations, and payment preferences in your broadcast to attract the right partners.</p>`
        },
        {
            question: 'What information should I include in a laptop WTS listing?',
            answer: `<p>High-performing listings usually include:</p>
                    <ul>
                      <li>Brand and model</li>
                      <li>CPU, RAM, SSD/HDD, and screen size</li>
                      <li>Condition grade and battery health notes</li>
                      <li>Quantity, location, and shipping scope</li>
                      <li>Price indication and minimum lot size</li>
                    </ul>
                    <p>Complete details reduce back-and-forth and improve buyer trust.</p>`
        }
    ],
    'server-storage': [
        {
            question: 'What is the Server/Storage Broadcast category?',
            answer: `<p>The Server/Storage Broadcast category shows live <strong>Want-to-Buy (WTB)</strong> and <strong>Want-to-Sell (WTS)</strong> posts for enterprise servers, storage systems, and related hardware in the circular IT market.</p>
                    <p>You will typically find brands such as Dell, HPE, Lenovo, IBM, Cisco, Supermicro, NetApp, and Fujitsu, plus related items such as disk shelves, controllers, rails, PSUs, and memory upgrades.</p>`
        },
        {
            question: 'How do I see only Want-to-buy (WTB) server offers?',
            answer: `<p>Use the list-type filter in Broadcast Search and select <strong>WTB</strong>, or open this direct URL: https://www.thebrokersite.com/broadcasts-refurbished-servers/wtb</p>
                    <p>Sign in to view full details and contact information. If you are new, you can apply for a trial at https://www.thebrokersite.com/register</p>`
        },
        {
            question: 'How do I see only Want-to-sell (WTS) server offers?',
            answer: `<p>Use the list-type filter in Broadcast Search and select <strong>WTS</strong>, or open this direct URL: https://www.thebrokersite.com/broadcasts-refurbished-servers/wts</p>
                    <p>Sign in to access complete listings and supplier contact details. New users can register for a trial at https://www.thebrokersite.com/register</p>`
        },
        {
            question: 'How can I receive server broadcasts by email?',
            answer: `<p>To receive Server/Storage broadcasts by email, your company needs an active TheBrokerSite membership.</p>
                    <p>After verification and activation, you can subscribe to the Server/Storage list and receive updates directly in your inbox, including full post details and sender contact information.</p>`
        },
        {
            question: 'Why did a server broadcast disappear or move down quickly?',
            answer: `<p>The feed updates continuously with a high daily volume of new broadcasts, so listings can move to later pages quickly.</p>
                    <p>Posts may also be removed by the sender once a deal is completed or inventory is no longer available.</p>`
        },
        {
            question: 'Which server and storage types are commonly traded on TheBrokerSite?',
            answer: `<p>You can find many segments, including:</p>
                    <ul>
                      <li>Rack and tower servers (for example Dell PowerEdge and HPE ProLiant)</li>
                      <li>Blade and modular systems</li>
                      <li>SAN/NAS storage arrays and disk shelves</li>
                      <li>Spare parts such as CPUs, RAM, HDDs/SSDs, and power supplies</li>
                    </ul>
                    <p>Availability changes daily based on active WTB and WTS demand.</p>`
        },
        {
            question: 'Can I search server broadcasts by brand, model, or specs?',
            answer: `<p>Yes. Use keyword search and filters to narrow by brand, model family, CPU generation, RAM, drive configuration, form factor, or other terms included by the seller or buyer.</p>
                    <p>For best results, combine the Server/Storage category with specific keywords such as "PowerEdge R740", "ProLiant DL380", or "ThinkSystem SR650".</p>`
        },
        {
            question: 'Are the servers in this category new or refurbished?',
            answer: `<p>Most listings in this B2B channel involve used, refurbished, or ex-lease enterprise equipment, although listing condition depends on each member post.</p>
                    <p>Always review the broadcast details and confirm grading, testing status, warranty terms, and cosmetic or functional condition directly with the trading partner.</p>`
        },
        {
            question: 'How do I post a WTB or WTS server broadcast?',
            answer: `<p>After signing in, open the Broadcast page, choose the <strong>Server/Storage</strong> category, select <strong>WTB</strong> or <strong>WTS</strong>, and add a clear description with quantity, condition, configuration, and preferred region.</p>
                    <p>A detailed post improves response quality and helps you close deals faster.</p>`
        },
        {
            question: 'Is TheBrokerSite suitable for international server and storage trade?',
            answer: `<p>Yes. TheBrokerSite connects IT traders and suppliers across multiple countries, making it suitable for both local and cross-border enterprise hardware sourcing.</p>
                    <p>For international deals, include region, logistics expectations, Incoterms if relevant, and payment preferences in your broadcast to attract the right partners. For higher-value shipments, consider <a href="/escrow">escrow</a>.</p>`
        },
        {
            question: 'What information should I include in a server WTS listing?',
            answer: `<p>High-performing listings usually include:</p>
                    <ul>
                      <li>Brand, model, and form factor (rack/tower/blade)</li>
                      <li>CPU, RAM, drive configuration, and RAID/controller details</li>
                      <li>Condition grade and testing notes</li>
                      <li>Quantity, location, and shipping scope</li>
                      <li>Price indication and minimum lot size</li>
                    </ul>
                    <p>Complete details reduce back-and-forth and improve buyer trust.</p>`
        }
    ],
    how_to_create_a_broadcast: [
        {
            question: "Where can I see my broadcasts?",
            answer: "You can view all your broadcasts by navigating to the Broadcast section and selecting the “My Broadcasts” tab. This area provides a centralized overview of your activity, including previously sent broadcasts and any that are scheduled. From here, you can quickly review content, track what has been sent, and manage your communication history."
        },
        {
            question: "How many images can I upload?",
            answer: "Each broadcast allows you to upload up to five images. This limit is designed to give you enough flexibility to visually support your message while ensuring broadcasts remain clear, fast to load, and easy for recipients to engage with."
        },
        {
            question: "What file types are supported for image uploads?",
            answer: "We support commonly used image formats, including PNG, JPG, JPEG, and WEBP. For the best experience, we recommend uploading images that are clear, properly sized, and optimized for web use. Avoid overly large files to ensure faster upload times and better performance across devices."
        },
        {
            question: "What happens if I miss a required field?",
            answer: "If a required field is left incomplete, the system will automatically highlight the missing information and display a validation message. This helps guide you in completing all necessary fields before submission, ensuring your broadcast is sent successfully without missing important details."
        },
        {
            question: "What should I do if my broadcast fails to send?",
            answer: "If your broadcast does not send successfully, start by checking your internet connection and verifying that all required fields are completed correctly. You may also want to review any uploaded content for potential issues. If the problem persists after retrying, please contact support for further assistance."
        },
        {
            question: "Can I edit a broadcast after sending?",
            answer: "Once a broadcast has been published, it cannot be edited. This helps maintain consistency and reliability in delivered communications. We recommend reviewing your message carefully before sending to ensure all information is accurate and complete."
        },
        {
            question: "Can I resend a broadcast?",
            answer: "Yes, you can resend an existing broadcast if needed. This can be useful for follow-ups, reminders, or reaching recipients who may have missed the original message. Simply select the broadcast and use the resend option to send it again."
        },
        {
            question: "Is there a limit to how many broadcasts I can send?",
            answer: "Yes, there are daily limits in place to ensure fair usage and optimal system performance. You can send up to 20 broadcasts per account per day, with a maximum of 5 broadcasts per broadcast list per day. These limits help maintain stability while still allowing regular communication."
        }
    ],
    how_to_save_broadcast_search: [
        {
            question: "What is a saved broadcast search?",
            answer: "A saved broadcast search allows you to store your search criteria, including keywords and filters, so you can easily track new want-to-buy (WTB) and want-to-sell (WTS) broadcasts that match your interests."
        },
        {
            question: "How do saved broadcast searches work?",
            answer: "When a new broadcast is posted, the system compares it against your saved search criteria. If a match is found, you can receive an email notification based on your selected alert preference."
        },
        {
            question: "Can I choose how often I receive notifications?",
            answer: "Yes. When saving a search, you can choose between immediate email updates for new matches or a daily digest that summarizes all matching broadcasts found during the day."
        },
        {
            question: "Can I edit or delete a saved search?",
            answer: "Yes. You can manage your saved searches at any time from the Saved Searches page, where you can update search criteria, change notification settings, or remove searches you no longer need."
        },
        {
            question: "How can I see my saved searches?",
            answer: `You can view your saved searches by going to the Home or Broadcast page. Below the search bar, click the "Saved Searches" tab alongside other tabs like All Broadcasts, Favorites, and My Broadcasts. This will display all your saved search criteria and allow you to manage them easily.`
        }
    ], 
    'how_to_manage_broadcast_email' : [
        {
            question: "What are broadcast email settings?",
            answer: "Broadcast email settings let you control how you receive emails for different broadcast list types, such as PC, Laptop, Components, and more."
        },
        {
            question: "What is the difference between No Email, Standard, and Digest?",
            answer: "No Email means you won't receive emails for that list type. Standard sends emails instantly when a broadcast is posted. Digest sends one daily summary of all broadcasts."
        },
        {
            question: "Can I set different email preferences per broadcast list?",
            answer: "Yes. You can configure each list type individually based on your preferred notification style."
        },
        {
            question: "Where can I manage my broadcast email settings?",
            answer: "You can manage your settings from the Broadcast Settings page or through the Broadcast page by clicking the More button and selecting Broadcast Settings. You can also access it directly here: https://www.thebrokersite.com/broadcast-settings"
        },
        {
            question: "Will I still be able to send broadcasts if I select No Email?",
            answer: "Yes. No Email only affects notifications. You can still send broadcasts normally."
        },
        {
            question: "How does the Digest option work?",
            answer: "Digest combines all matching broadcasts into a single daily email summary sent at the end of the day."
        },
    ]
}
